import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      links={[
        // 可以添加你自己的链接，例如：
        // {
        //   key: 'privacy',
        //   title: '隐私政策',
        //   href: '/privacy',
        //   blankTarget: false,
        // },
        // {
        //   key: 'terms',
        //   title: '服务条款',
        //   href: '/terms',
        //   blankTarget: false,
        // },
      ]}
    />
  );
};

export default Footer;
